<template>
  <!-- 金額輸入列 -->
  <div class="colu-12">
    <label
      class="colu-12 for-label"
      :for="inputId"
    >
      <template v-if="isCryptoExchange">
        {{ $t('Bao.please_enter_purchase_amount') }}
      </template>
      <template v-else>
        {{ $t('Bao.please_enter_withdrawal_amount') }}
      </template>
    </label>

    <div class="row-frame">
      <div :class="isPC ? 'colu colu-9' : 'colu colu-8'">
        <input
          :id="inputId"
          :value="amount"
          :placeholder="$t('Bao.input_withdrawal_amount')"
          class="for-input inpType"
          autocomplete="off"
          type="text"
          @input="onInput"
          @keypress="onlyNumbers"
        >
      </div>
      <div :class="isPC ? 'colu colu-3' : 'colu colu-4'">
        <button
          class="btn button-style btn-creat"
          @click.prevent="$emit('set-all')"
        >
          {{ $t('Bao.withdrawal_all') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  name: 'AmountInput',
  props: {
    amount: {
      type: [String, Number],
      default: ''
    },
    isCryptoExchange: {
      type: Boolean,
      default: false
    },
    /** 供 label[for] 綁定，避免 MB/PC 同頁面 id 重複 */
    inputId: {
      type: String,
      default: 'withdraw-amount-input'
    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  },
  methods: {
    onInput(event) {
      this.$emit('update:amount', event.target.value)
      this.$emit('input', event)
    },
    onlyNumbers(event) {
      if (
        !/[0-9]/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'Enter'].includes(event.key)
      ) {
        event.preventDefault()
      }
    }
  }
}
</script>
